<template>
  <div
    :id="id"
    class="board"
    @dragover.prevent="dragedOver"
    @dragleave="dragLeft"
    @drop.prevent="drop"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: ["id"],
  data: function() {
    return {};
  },
  methods: {
    drop(e) {
      const card_id = e.dataTransfer.getData("card_id");
      const card = document.getElementById(card_id);
      const oldBoxId = e.dataTransfer.getData("box_id");
      e.target.style.border = "none";
      e.target.appendChild(card);
      this.$emit("itemMoved", card_id, oldBoxId, e.target.id);
    },
    dragedOver: e => {
      e.target.style.border = "3px dotted black";
    },
    dragLeft: e => {
      e.target.style.border = "none";
    }
  }
};
</script>

<style scoped>
</style>
